
export enum LGEElectionStatusEnum {
    preElection = "preElection",
    election = "election",
    requiresSupElection = "requiresSupElection",
    nonElection = "nonElection",
    notPublic = "notPublic"
}